



























/** @format */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getImgSrc, uploadImage } from '@/api/parking-lot-management';
import { API_SERVER } from '@root/common/config';
import { FETCH_IMGRUL } from '@/store/mutation-types';
import { Getter, Mutation } from 'vuex-class';
import { isShiDaill } from '@/utils/env';
@Component
export default class showImage extends Vue {
  @Prop({ default: {} })
  uploadImage?: uploadImage;
  @Prop({ default: '' })
  imgFile?: any; //文件地址
  @Mutation(`dictionaries/${FETCH_IMGRUL}`)
  changeImgUrl!: Function;
  setCurrentTab!: Function;
  private imgBaseImg = `${API_SERVER.imgBaseUrl}`;
  private defaultImg = `${API_SERVER.defaultImg}`;
  defaultImage = 'https://fileservice.szccbt.com/default_car_image.jpg';
  loadingFlag: boolean = false;
  imgSrc: string = '';
  // @ts-ignore
  isWenLv: boolean = 'wenlv,wenlvtest'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV); //查看图片文旅定制化
  isshidaill: boolean = isShiDaill;
  previewVisible: boolean = false;
  previewImage: string = '';
  async getImage(img: uploadImage) {
    try {
      this.loadingFlag = true;
      let { data } = await getImgSrc(img);
      this.imgSrc = data || this.defaultImage;
    } catch (e) {
      this.imgSrc = this.defaultImage;
    } finally {
      this.loadingFlag = false;
    }
  }
  toMaxImg() {
    this.previewImage = (this.$refs.parkImg as any).src || this.defaultImage;
    this.previewVisible = true;
  }
  handlePreviewCancel() {
    this.previewVisible = false;
  }
  created() {
    if (this.isWenLv || this.isshidaill) {
      this.getImage(this.uploadImage);
    }
  }
}
